// extracted by mini-css-extract-plugin
export default {"tag":"GridActionRowTag_tag__qnRgc","selected":"GridActionRowTag_selected__S2ZLx"};